// extracted by mini-css-extract-plugin
export default {"no-loads-advice":"LoadsTable_no-loads-advice__HvuV0","loads-table":"LoadsTable_loads-table__hoptS","loads-table-col-name":"LoadsTable_loads-table-col-name__k9q6W"};